import React, { Component } from "react"
import 'bootstrap/dist/css/bootstrap.min.css'

import './ApplicationInterview.css'
import './EmailVerification.css'
import { Modal } from 'antd'
import Row from 'react-bootstrap/Col'
import { State, LoanOverview } from '../State'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import { Button } from "react-bootstrap"
import CodeVerification from "../Common/components/CodeVerification"
import CheckGroup from "../Common/components/CheckGroup"
import { connect } from 'react-redux'
import * as act from "../Store/actions"
import * as prgr from "../Store/progress"
import * as st from "../State"
import * as com from "../Common"
import { getCurrentState, loadState, updateState, mergeState } from '../Store'
import { UpdateChangeProgress, UpdateChangeLastTouch } from "../Store/progress"
import Spinner from 'react-bootstrap/Spinner'
import {Input, Spin, Space, Button as But} from "antd";
import dayjs from 'dayjs'
import { updateStatsigUser, withStatsig } from "../statsig/statsigMethod"
import { track, flushThenLeave, patchStatsigIdentity } from "../statsig"
import { STATSIG } from "../statsig/events"
import { trackLoanInsert } from "../statsig/trackLoanInsert"
import { APPLICATION_V2_CONTINUE_PATH } from "../ApplicationV2/resumePath"

/**
 * Loan state arrives as a JSON string. It can be empty or malformed for loans
 * that were never worked on, and JSON.parse("") throws -- which used to escape
 * all the way out of the verification handler.
 */
const parseLoanState = (raw) => {
    if (!raw) return null
    try {
        return JSON.parse(raw)
    } catch (e) {
        console.log("could not parse loan state", e)
        return null
    }
}

const mapStateToProps = (state) => {
    return {
        application: state.application,
        progress: state.progress,
    }
}


const mapDispatchToProps = (dispatch) => ({

    updateCoborrower: (event) => {
        dispatch(act.UpdateHasCoborrower(event.target.value))
    },
    changeMainPropertyAttribute: (t, verb) => {
        dispatch(act.ChangeMainPropertyAttribute(t, verb))
    },
    changeBorrowerInfo: (event, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(event.target.value, who, verb))
    },
    updateBorrower: (key, e) => {
        dispatch(act.ChangeBorrowerInfo(e, "borrower", key))
    },
    updateChangeLastTouch: (t) => {
        dispatch(UpdateChangeLastTouch(t))
    },
    updateChangeApplication: (application) => {
        dispatch(act.updateApplication(application))
    },
    updateChangeProgress: (tab, index) => {
        dispatch(prgr.UpdateChangeProgress(tab, index))
    },
    updateChangeProgressType: (tab) => {
        dispatch(prgr.UpdateChangeProgressType(tab))
    },
    updateChangeVisitedStage: (step, stage) => {
        dispatch(prgr.UpdateChangeVisitedStage(step, stage))
    },
})

class EmailVerification extends Component {

    constructor(props) {
        super(props)
        this.state = {
            code: "",
            verified: false,
            showResult: false,
            verifingCode: false,
            sendingCode: false,
            showPastLoansModal: false,
            selectedLoanId: "",
            pastLoans: [],
            currentLoanId: "",
            loading: false,
            showCodeArea: false,
            // Empty falls back to the "code is incorrect or expired" copy, which
            // is only right when the code really was rejected.
            errorMessage: ""
        }
        this.isPrequal = this.props.application.property.purpose === "purchase" && !this.props.application.property.hascontract
        this.isHardMoneyLoan = this.props.application.product.mortgageapplied === "hardmoneyloan" || this.props.purpose === "hardmoneyloan"

        const searchParams = new URLSearchParams(window.location.search)
        this.leadsChannel = searchParams.get('leadschannel')
    }

    trackSignupSuccessAndLeave = (path, source, response) => {
        const customerId =
            sessionStorage.getItem("cid") || this.props.customerid || ""
        const purpose = this.props.application?.property?.purpose || this.props.purpose || ""
        const email = (this.props.application.borrower.email || "").toLowerCase()
        patchStatsigIdentity({
            user_account: email,
            customer_id: customerId,
        })
        // signupfrompreapp：注册 + 首笔 loan，各打一次
        track(STATSIG.AUTH.SIGNUP, customerId, {
            customer_id: customerId,
            source,
            purpose,
            loid: sessionStorage.getItem("loid") || "",
        })
        trackLoanInsert(
            {
                Status: "OK",
                LoanID: response?.LoanID || response?.Loanid || response?.loanid || "",
            },
            source
        )
        flushThenLeave(() => {
            window.location.href = path
        })
    }

    sendcode = () => {
        this.setState({ sendingCode: true, showResult:false, verified: true })
        fetch("/auth/generateonetimepasscode", {
            cache: 'no-cache',
            method: 'POST',
            body: JSON.stringify({
                email: this.props.application.borrower.email.toLowerCase(),
                customerID: sessionStorage.getItem("cid") || this.props.customerid,
                loID: sessionStorage.getItem("loid") === null ? "" : sessionStorage.getItem("loid"),
            }),
            headers: {
                'Content-Type': 'application/json',
                Cache: "no-cache"
            },
        }).then(response => {
            let d = new Date()
            //console.log(JSON.stringify(response))
            if (!response.ok) {
                console.log(response)

            } else {
                this.setState({showCodeArea:true})
                // console.log(response)

            }
            this.setState({ sendingCode: false })
        }).catch(error => {
            console.log(error)
        })
    }

    verifycodeAndCheckPastLoans = (code) => {
        this.setState({ verifingCode: true, errorMessage: "" })
        fetch("/auth/verifycodeandcheckpastloans", {
            cache: 'no-cache',
            method: 'POST',
            body: JSON.stringify({
                email: this.props.application.borrower.email.toLowerCase(),
                firstName: this.props.application.borrower.firstname,
                lastName: this.props.application.borrower.lastname,
                code: code,
                customerID: sessionStorage.getItem("cid") || this.props.customerid,
                loID: sessionStorage.getItem("loid") === null ? "" : sessionStorage.getItem("loid"),
                State: JSON.stringify(loadState()), // change to com.ascii2hex(sessionStorage.getItem("state")) ?
            }),
            headers: {
                Cache: "no-cache"
            },
        }).then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status)
                this.setState({ showResult: true, verified: false, verifingCode: false, code: "" })
                return
            }
            response.json().then(js => {
                updateStatsigUser(this.props.statsigClient, this.props.application.borrower.email.toLowerCase())
                if (js.NeedConvertLeads) {
                    this.convertMarketplaceLeads()
                } else {
                    if (js.AlreadySignedUp === false) {
                        this.signup()
                    } else {
                        // A borrower can be signed up and still have nothing to
                        // reuse -- the loan was created LO-side and they never
                        // opened it. The server used to answer `loans: null` for
                        // that, and .forEach on null threw right here.
                        const pastLoans = ((js.LoanStates && js.LoanStates.loans) || [])
                            .map(loan => ({
                                ...loan,
                                state: parseLoanState(loan.state),
                                lostate: parseLoanState(loan.lostate),
                            }))
                            // The modal reads state.progress and
                            // state.application.property; drop anything it
                            // cannot render instead of crashing on it.
                            .filter(loan => loan.state && loan.state.progress && loan.state.application && loan.state.application.property)
                        if (pastLoans.length === 0) {
                            // Nothing to choose from. The modal would come up
                            // empty with its only real button disabled, so take
                            // the same path its "Skip" link takes.
                            this.createNew(false)
                            return
                        }
                        this.setState({ showPastLoansModal: true, pastLoans, currentLoanId: js.LoanStates.loanid, verifingCode: false, code: "", showResult: false, verified: true, })
                    }
                }
            })

        }).catch(error => {
            // Anything thrown above lands here, including a render-data problem
            // that has nothing to do with the code the borrower typed. Clearing
            // verifingCode is what matters: the spinner replaces the code input,
            // so leaving it on strands them with no way to retry.
            console.log(error)
            this.setState({
                showResult: true,
                verified: false,
                verifingCode: false,
                code: "",
                errorMessage: "Something went wrong on our end. Please try again.",
            })
        })
    }

    signup = () => {
        this.setState({ verifingCode: true })
        fetch("/auth/signupfrompreapp", {
            cache: 'no-cache',
            method: 'POST',
            body: JSON.stringify({
                email: this.props.application.borrower.email.toLowerCase(),
                firstName: this.props.application.borrower.firstname,
                lastName: this.props.application.borrower.lastname,
                customerID: sessionStorage.getItem("cid") || this.props.customerid,
                loID: sessionStorage.getItem("loid") === null ? "" : sessionStorage.getItem("loid"),
                State: JSON.stringify(loadState()),
                IsNonQM: this.props.purpose==="nonqm" ? true : false,
                LeadsChannel: this.leadsChannel,
            }),
            headers: {
                Cache: "no-cache"
            },
        }).then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status)
                this.setState({ showResult: true, verified: false, verifingCode: false, code: "" })
                return
            }
            response.json().then(js => {

                if (js.Status !== "OK") {
                    console.log(js)
                    this.setState({ showResult: true, verified: false, verifingCode: false, code: "" })
                } else {
                    if (this.props.onFinish) {
                        this.props.onFinish()
                    }

                    sessionStorage.setItem("ZeitroA", js.Token)
                    let state = State.fromJson(JSON.parse(js.State))
                    state.application.currentStatus = 'ApplicationStarted'
                    state.application.currentStage = 'Application'
                    if (this.isHardMoneyLoan) {
                        state.application.product.mortgageapplied = "hardmoneyloan"
                    }
                    state.application.loanOverview = new LoanOverview()
                    state.application.loanOverview.receivedDate = new Date().toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric'})  
                    let statejs = state.toJson()
                    sessionStorage.removeItem("state")
                    sessionStorage.setItem("state", statejs)
                    sessionStorage.setItem("originalstate", statejs)
                    sessionStorage.setItem("newcustomer", "false")
                    let path = APPLICATION_V2_CONTINUE_PATH
                    if (this.isHardMoneyLoan) {
                        sessionStorage.setItem("isHardMoneyLoanCustomer", true)
                        path = "/application/hardmoneyloan/interview/main/borrower"
                    }
                    this.trackSignupSuccessAndLeave(path, "preapp", js)
                    this.setState({ showResult: true, verified: true, verifingCode: false, code: "" })
                }
            })

        }).catch(error => {
            // verifingCode gates the spinner that replaces the code input, so
            // it has to come off on every exit path or the borrower is stranded.
            console.log(error)
            this.setState({
                showResult: true,
                verified: false,
                verifingCode: false,
                code: "",
                errorMessage: "Something went wrong on our end. Please try again.",
            })
        })
    }

    convertMarketplaceLeads = () => {
        this.setState({ verifingCode: true })
        fetch("/auth/convertmarketplaceleads", {
            cache: 'no-cache',
            method: 'POST',
            body: JSON.stringify({
                email: this.props.application.borrower.email.toLowerCase(),
                firstName: this.props.application.borrower.firstname,
                lastName: this.props.application.borrower.lastname,
                customerID: sessionStorage.getItem("cid") || this.props.customerid,
                loID: sessionStorage.getItem("loid") === null ? "" : sessionStorage.getItem("loid"),
                State: JSON.stringify(loadState()),
                IsNonQM: this.props.purpose==="nonqm" ? true : false,
                LeadsChannel: this.leadsChannel,
            }),
            headers: {
                Cache: "no-cache"
            },
        }).then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status)
                this.setState({ showResult: true, verified: false, verifingCode: false, code: "" })
                return
            }
            response.json().then(js => {

                if (js.Status !== "OK") {
                    console.log(js)
                    this.setState({ showResult: true, verified: false, verifingCode: false, code: "" })
                } else {
                    if (this.props.onFinish) {
                        this.props.onFinish()
                    }

                    sessionStorage.setItem("ZeitroA", js.Token)
                    let state = State.fromJson(JSON.parse(js.State))
                    if (this.isHardMoneyLoan) {
                        state.application.product.mortgageapplied = "hardmoneyloan"
                    }
                    let statejs = state.toJson()
                    sessionStorage.removeItem("state")
                    sessionStorage.setItem("state", statejs)
                    sessionStorage.setItem("originalstate", statejs)
                    sessionStorage.setItem("newcustomer", "false")
                    let path = APPLICATION_V2_CONTINUE_PATH
                    if (this.isHardMoneyLoan) {
                        sessionStorage.setItem("isHardMoneyLoanCustomer", true)
                        path = "/application/hardmoneyloan/interview/main/borrower"
                    }
                    this.trackSignupSuccessAndLeave(path, "preapp_marketplace", js)
                    this.setState({ showResult: true, verified: true, verifingCode: false, code: "" })
                }
            })

        }).catch(error => {
            // verifingCode gates the spinner that replaces the code input, so
            // it has to come off on every exit path or the borrower is stranded.
            console.log(error)
            this.setState({
                showResult: true,
                verified: false,
                verifingCode: false,
                code: "",
                errorMessage: "Something went wrong on our end. Please try again.",
            })
        })
    }

    verifycode = (code) => {
        this.setState({ verifingCode: true })
        fetch("/auth/verifycodeandsignup", {
            cache: 'no-cache',
            method: 'POST',
            body: JSON.stringify({
                email: this.props.application.borrower.email.toLowerCase(),
                firstName: this.props.application.borrower.firstname,
                lastName: this.props.application.borrower.lastname,
                code: code,
                customerID: sessionStorage.getItem("cid") || this.props.customerid,
                loID: sessionStorage.getItem("loid") === null ? "" : sessionStorage.getItem("loid"),
                State: JSON.stringify(loadState()),
            }),
            headers: {
                Cache: "no-cache"
            },
        }).then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status)
                this.setState({ showResult: true, verified: false, verifingCode: false, code: "" })
                return
            }
            response.json().then(js => {

                if (js.Status !== "OK") {
                    console.log(js)
                    this.setState({ showResult: true, verified: false, verifingCode: false, code: "" })
                } else {
                    sessionStorage.setItem("ZeitroA", js.Token)
                    let state = State.fromJson(JSON.parse(js.State))
                    let statejs = state.toJson()
                    sessionStorage.removeItem("state")
                    sessionStorage.setItem("state", statejs)
                    sessionStorage.setItem("originalstate", statejs)
                    sessionStorage.setItem("newcustomer", "false")
                    let path = APPLICATION_V2_CONTINUE_PATH
                    if (this.isHardMoneyLoan) {
                        path = "/application/hardmoneyloan/interview/main/borrower"
                    }
                    this.trackSignupSuccessAndLeave(path, "preapp_verify_signup", js)
                    this.setState({ showResult: true, verified: true, verifingCode: false, code: "" })
                }
            })

        }).catch(error => {
            // verifingCode gates the spinner that replaces the code input, so
            // it has to come off on every exit path or the borrower is stranded.
            console.log(error)
            this.setState({
                showResult: true,
                verified: false,
                verifingCode: false,
                code: "",
                errorMessage: "Something went wrong on our end. Please try again.",
            })
        })
    }

    componentDidMount() {
        if (this.props.mode === "simple") {
            
        } else {
            this.sendcode()
        }
    }


    isValidated() {
        if (!this.form.current.reportValidity()) {
            this.setState({ validated: true })
            return false
        };
        return true
    }
    handleSubmit = e => {
        if (!this.state.verified) {
            return false
        }
        return true

    }

    createNew(withRecord) {
        this.setState({ loading: true })
        let token = sessionStorage.getItem("ZeitroA")
        let js = {
            Email: this.props.application.borrower.email.toLowerCase(),
            CustomerID: sessionStorage.getItem("cid") || this.props.customerid,
            LoanID: this.state.selectedLoanId !== "" ? this.state.selectedLoanId : "",
            NewState: withRecord ? "" : com.ascii2hex(sessionStorage.getItem("state")),
            LoID: sessionStorage.getItem("loid") === null ? "" : sessionStorage.getItem("loid"),
        }
        fetch('/auth/createnewapplication', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
            body: JSON.stringify(js)
        }).then(
            response => {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                        response.status)
                    window.document.dispatchEvent(new Event('reauthenticate'), "")
                    // This can now be reached straight from code verification,
                    // so the verification spinner has to come off too.
                    this.setState({ loading: false, verifingCode: false, showResult: true, verified: false, errorMessage: "Something went wrong on our end. Please try again." })
                    return
                }
                response.json().then(js => {
                    if (js.Status !== "OK") {
                        console.log(js.Text)
                        this.setState({ loading: false, verifingCode: false, showResult: true, verified: false, errorMessage: "Something went wrong on our end. Please try again." })
                        alert("Looks like there was a problem, please try later.")
                    } else {
                        if (this.props.onFinish) {
                            this.props.onFinish()
                        }
                        trackLoanInsert(js, "email_verification")
                        sessionStorage.setItem("ZeitroA", js.Token)
                        // if (withRecord) {
                        let st = JSON.parse(js.State)
                        st.progress.stage = "interview"
                        st.progress.interviewfinished = false
                        st.progress.interviewstarted = false
                        st.progress.productselectionstarted = false
                        st.progress.interview.step = 0
                        st.progress.interview.max = 0
                        st.application.currentStatus = 'ApplicationStarted'
                        st.application.currentStage = 'Application'
                        st.application.selection.selectedloan = null
                        st.application.property.purpose = this.props.application.property.purpose
                        st.application.property.hascontract = false
                        st.application.borrower.firstname = this.props.application.borrower.firstname
                        st.application.borrower.lastname = this.props.application.borrower.lastname
                        st.application.loanOverview = new LoanOverview()
                        st.application.loanOverview.receivedDate = new Date().toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric'})  
                        this.props.updateChangeApplication(st.application)
                        this.props.updateChangeVisitedStage("interviewstarted")
                        this.props.updateChangeProgress(0, "max")
                        this.props.updateChangeProgress(0, "interview")
                        getCurrentState()
                        com.touch()
                        // } else {

                        // }
                        this.setState({ loading: false })
                        let path = APPLICATION_V2_CONTINUE_PATH
                        if (this.isHardMoneyLoan) {
                            path = "/application/hardmoneyloan/interview/main/borrower"
                        }

                        window.location.href = path
                    }

                })
            }
        ).catch((err) => {
            this.setState({ loading: false, verifingCode: false, showResult: true, verified: false, errorMessage: "Something went wrong on our end. Please try again." })
            console.log('Fetch Error :', err)
        })
    }
    editEmail = (type) => {
        this.props.back(type)
    }
    render() {
        const showErrorMeesage = () => {
            return (
                <div className="d-flex justify-content-center">

                    <div style={{ backgroundColor: "#FFE6BF", borderRadius: "4px", padding: "10px", marginTop: "15px", maxWidth: "350px" }}>
                        <img src="/images/warningSignYellow.png" style={{ width: "18px", height: "18px", marginRight: "10px" }} />
                        <a>{this.state.errorMessage || "The code is incorrect or expired."}</a>
                    </div>
                </div>
            )
        }

        const showPastLoans = () => {
            if (!this.state.showPastLoansModal) {
                return ""
            }
            let propertyType = {
                'singlefamilydetached': 'Single Family',
                'singlefamilyattached': 'Townhouse',
                'twotofourfamily': 'Multi-family',
                'condominium': 'Condo'
            }
            let filterValue = (val) => {
                return val && val !== '' ? val : '--'
            }
            const data = []
            for (let loan of this.state.pastLoans) {
                let lasttouch = new Date(loan.state.progress.lasttouch)
                let isPrequal = loan.state.application.property.purpose === "purchase" && !loan.state.application.property.hascontract
                if (loan.state.application.property.purpose === null) {
                    data.push({
                        value: loan.loanid,
                        label: <div>
                            <div>Loan purpose unselected</div>
                        </div>
                    })
                } else {
                    data.push({
                        value: loan.loanid,
                        label: (
                            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <div>
                                    <div><b>{com.capitalize(loan.state.application.property.purpose)}</b> {!isPrequal ? " | Application" : " | Pre-qualification"}</div>
                                    <div className="mt-2" style={{ fontSize: '14px' }}>{filterValue(propertyType[loan.state.application.property.propertytype]) + ", " + filterValue(loan.state.application.property.county) + ", " + filterValue(loan.state.application.property.state)}</div>
                                </div>
                                <div style={{ color: "#6E6E70", fontSize: '14px', marginTop: '6px' }}>Last edit at {lasttouch.toLocaleDateString()}</div>
                            </div>
                        )
                    })
                }
            }


            return (
                <Modal
                    style={{
                        top: 0
                    }}
      wrapClassName='full-height-modal'
                    className="pastLoansModal"
                    open={this.state.showPastLoansModal}
                    title="Use a previous application"
                    onOk={() => this.setState({ showPastLoans: false })}
                    onCancel={() => this.setState({ showPastLoansModal: false })}
                    width="768px"
                    maskClosable={false}
                    closable={false}
                    footer={[
                        <Button style={{ marginRight: 18 }} variant="zeitro-primary"
                            disabled={this.state.selectedLoanId === "" ? true : false}
                            onClick={() => this.createNew(true)}>
                            Auto fill my information
                        </Button>,
                        <Button style={{ color: '#325CEB', fontWeight: 700 }} variant="link" onClick={() => this.createNew(false)}>
                            <span className='pastLoansModal-btn-pc'>Skip</span><span className='pastLoansModal-btn-mobile'>create new</span>
                        </Button>,
                    ]}
                >
                    <div className="pastLoansModal-title">We noticed that you have {this.state.pastLoans.length} existing applications. Would you like to use the information from one of them for this application?</div>
                    <div className="subheading">You can edit your information any time during the application process.</div>
                    <div style={{ margin: '26px 0', overflow: 'auto', flex: 1 }}>
                        <CheckGroup
                            data={data}
                            onChangeSelect={e => {
                                this.setState({ selectedLoanId: e })
                            }}
                            value={this.state.selectedLoanId}
                            mode="flex"
                            type='radio'
                            direction="horizontal"
                            fixedWidth="280px" />
                    </div>
                </Modal>
            )
        }

        if (this.state.showResult && this.state.verified) {
            return (
                <div className="text-center mb-3">
                    <img src="/images/emailSuccess.png" style={{ width: "80px", height: "78px" }} />
                    <div className="prequalBigText">Succeed!</div>
                    <div className="prequalSmallText pt-2">
                        <div>Your account has been verified.</div>
                        <div>Continue to your application.</div>

                    </div>

                </div>
            )
        }

        if (this.props.mode === "simple") {
            return (
                <div>
                    {showPastLoans()}
                </div>
            )
        }

        return (
            <div className="text-center mb-3">


                <div style={{ marginBottom: 23 }}><img src="/images/saveProgress.png" style={{ height: "71px" }} /></div>
                <div className="prequalBigText prequalCheckText">Check your email</div>
                {/* <div className="prequalSmallText pt-2 text-wrap">Please enter the 4 digit code sent to {this.props.application.borrower.email}</div> */}
                {
                    this.props.application.borrower.email && (
                        <div style={{ margin: '6px auto 18px', color: '#6E6E70', lineHeight: '20px' }}>
                            <div>We sent a code to <span style={{ fontWeight: 600, color: '#222' }}>{this.props.application.borrower.email}</span><a style={{ color: '#325CEB', marginLeft: 8, textDecorationLine: 'underline' }} className="prequalEditText" onClick={() => { this.editEmail(1) }}>Edit</a></div>
                            <div>Enter the code to log in your account</div>
                        </div>
                    )
                }
                <div style={{ display: "flex", justifyContent: "center", padding: "20px 0 0 10px" }}>
                    {(this.state.verifingCode || this.state.sendingCode) ? <Spinner animation="border" size="lg" /> : <CodeVerification value={this.state.code} onChange={(e) => {
                        this.setState({ code: e })
                        if (e.length === 4) {
                            this.verifycodeAndCheckPastLoans(e)
                        }
                    }} />}

                </div>
                {(this.state.showResult && !this.state.verified) && showErrorMeesage()}
                <div style={{ fontSize: 16 }} className="p-2">Didn’t receive the email? <a style={{ color: "#325CEB", textDecorationLine: "underline" }} onClick={() => {
                    this.sendcode()
                }}>Resend</a></div>
                {showPastLoans()}
            </div >
        )
    }
}

export default withStatsig(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(EmailVerification))
